
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'embedded-viral-link-ui',
  currentProjectVersion: 'static-1.6309',
  depVersions: {
  "embedded-viral-link-ui": "static-1.6309",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7920",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11366",
  "I18n": "static-7.1604",
  "jasmine-runner": "static-1.6376",
  "quartz": "static-1.6882",
  "quartz-core": "static-1.6101",
  "react-dlb": "static-1.77",
  "webpack-env": "static-1.54",
  "cssUtils": "static-1.771",
  "enviro": "static-4.428",
  "foundations-components": "static-1.7743",
  "history": "static-4.47",
  "hub-http": "static-1.6127",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11674",
  "icons": "static-2.639",
  "immer": "static-1.33",
  "laboratory-lib": "static-3.7067",
  "PortalIdParser": "static-2.388",
  "quartz-config": "static-1.660",
  "quartz-routing": "static-1.312",
  "quick-fetch": "static-1.3842",
  "react": "static-7.184",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16565",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5274",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "signup-constants": "static-1.18683",
  "signup-ui-lego-core": "static-1.20693",
  "styled-components": "static-2.88",
  "StyleGuideUI": "static-3.485",
  "ui-addon-react-router-dom": "static-1.9453",
  "ui-images": "static-2.1131",
  "UIComponents": "static-3.8313",
  "usage-tracker": "static-1.7244",
  "usage-tracker-core": "static-1.7094",
  "viral-links-lib": "static-1.6955",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.77",
  "metrics-js": "static-1.9542",
  "bend-plugin-trellis-migration": "static-1.3333",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3159",
  "quartz-webpack": "static-1.3106",
  "HeadJS": "static-2.736",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3031",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "foundations-theming": "static-1.4322",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4232",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.820",
  "hubspotter-http": "static-1.4578",
  "mobile-manifest-mixins": "static-1.509",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.557",
  "quartz-head": "static-1.547",
  "quartz-i18n": "static-1.557",
  "quartz-test": "static-1.557",
  "quartz-tracking": "static-1.261",
  "ui-fonts": "static-1.628",
  "usage-tracker-container": "static-1.7234",
  "sassPrefix": "static-1.154",
  "bend-plugin-foundations-components": "static-1.4012",
  "floating-ui": "static-1.54",
  "foundations-assets": "static-1.4759",
  "foundations-theming-specialty": "static-1.2038",
  "hs-story-utils": "static-1.9338",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1559",
  "superstore": "static-1.4677",
  "csstype": "static-1.50",
  "rpc-client-utils": "static-1.4552",
  "emoji-regex": "static-1.7",
  "PatternValidationJS": "static-1.437",
  "signup-ui-url-generator": "static-2.7943",
  "bender-build-tools": "static-1.3063",
  "bend-plugin-foundations-theming": "static-1.2805",
  "foundations-theming-base": "static-1.3307",
  "stylex": "static-1.30",
  "hub-http-shared-msw-handlers": "static-1.9747",
  "hubspotter-http-shared-msw-handlers": "static-1.9745",
  "usage-tracker-session-replay": "static-1.4930",
  "chirp-fetch": "static-1.1789",
  "ts-schema": "static-1.4004",
  "amplitude-session-replay-browser": "static-1.58"
},
  depPathPrefixes: {
  "embedded-viral-link-ui": "/embedded-viral-link-ui/static-1.6309",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7920",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11366",
  "I18n": "/I18n/static-7.1604",
  "jasmine-runner": "/jasmine-runner/static-1.6376",
  "quartz": "/quartz/static-1.6882",
  "quartz-core": "/quartz-core/static-1.6101",
  "react-dlb": "/react-dlb/static-1.77",
  "webpack-env": "/webpack-env/static-1.54",
  "cssUtils": "/cssUtils/static-1.771",
  "enviro": "/enviro/static-4.428",
  "foundations-components": "/foundations-components/static-1.7743",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6127",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11674",
  "icons": "/icons/static-2.639",
  "immer": "/immer/static-1.33",
  "laboratory-lib": "/laboratory-lib/static-3.7067",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "quartz-config": "/quartz-config/static-1.660",
  "quartz-routing": "/quartz-routing/static-1.312",
  "quick-fetch": "/quick-fetch/static-1.3842",
  "react": "/react/static-7.184",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16565",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5274",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "signup-constants": "/signup-constants/static-1.18683",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20693",
  "styled-components": "/styled-components/static-2.88",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9453",
  "ui-images": "/ui-images/static-2.1131",
  "UIComponents": "/UIComponents/static-3.8313",
  "usage-tracker": "/usage-tracker/static-1.7244",
  "usage-tracker-core": "/usage-tracker-core/static-1.7094",
  "viral-links-lib": "/viral-links-lib/static-1.6955",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.77",
  "metrics-js": "/metrics-js/static-1.9542",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3333",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3159",
  "quartz-webpack": "/quartz-webpack/static-1.3106",
  "HeadJS": "/HeadJS/static-2.736",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3031",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "foundations-theming": "/foundations-theming/static-1.4322",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4232",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.820",
  "hubspotter-http": "/hubspotter-http/static-1.4578",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.509",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.557",
  "quartz-head": "/quartz-head/static-1.547",
  "quartz-i18n": "/quartz-i18n/static-1.557",
  "quartz-test": "/quartz-test/static-1.557",
  "quartz-tracking": "/quartz-tracking/static-1.261",
  "ui-fonts": "/ui-fonts/static-1.628",
  "usage-tracker-container": "/usage-tracker-container/static-1.7234",
  "sassPrefix": "/sassPrefix/static-1.154",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4012",
  "floating-ui": "/floating-ui/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4759",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2038",
  "hs-story-utils": "/hs-story-utils/static-1.9338",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1559",
  "superstore": "/superstore/static-1.4677",
  "csstype": "/csstype/static-1.50",
  "rpc-client-utils": "/rpc-client-utils/static-1.4552",
  "emoji-regex": "/emoji-regex/static-1.7",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7943",
  "bender-build-tools": "/bender-build-tools/static-1.3063",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2805",
  "foundations-theming-base": "/foundations-theming-base/static-1.3307",
  "stylex": "/stylex/static-1.30",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9747",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9745",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4930",
  "chirp-fetch": "/chirp-fetch/static-1.1789",
  "ts-schema": "/ts-schema/static-1.4004",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58"
}
};
